var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItemIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.95825 14.25H4.74992V16.625H6.33325V14.25H12.6666V16.625H14.2499V14.25H15.0416C16.3478 14.25 17.4166 13.1813 17.4166 11.875V7.91667C17.4166 7.48125 17.0603 7.125 16.6249 7.125H3.16659V4.75C3.16659 3.87917 3.87909 3.16667 4.74992 3.16667C5.62075 3.16667 6.33325 3.87917 6.33325 4.75H7.91658C7.91658 3.00042 6.4995 1.58334 4.74992 1.58334C3.00034 1.58334 1.58325 3.00042 1.58325 4.75V11.875C1.58325 13.1813 2.652 14.25 3.95825 14.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemIcon2);
export default __webpack_public_path__ + "static/media/itemIcon2.e76c06e3dc401ae191b73c3bd4d6b7a1.svg";
export { ForwardRef as ReactComponent };